import { deleteCookie, setCookie } from '@cian/utils/lib/browser/cookie';

export function setRegionCookies(regionId: number, mainTownId: number | null | undefined) {
  if (typeof window === 'undefined') {
    return;
  }

  const currentDate = new Date();
  const expires = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

  setCookie('session_region_id', String(regionId), { secure: false, expires });
  setCookie('forever_region_id', String(regionId), { secure: false, expires }); // Кука главной cian.ru

  if (mainTownId) {
    setCookie('session_main_town_region_id', String(mainTownId), { secure: false, expires });
    setCookie('forever_main_town_region_id', String(mainTownId), { secure: false, expires });
  } else {
    deleteCookie('session_main_town_region_id');
    deleteCookie('forever_main_town_region_id');
  }
}
